export const SHOPPING_ASSISTANT = 'ai_shopping_assistant'
export const SHOPPING_ASSISTANT_NEW = 'ai_shopping_assistant_new'
export const SHOPPING_ASSISTANT_WEBVIEW = 'ai_shopping_assistant-webview'
export const SHOPPING_ASSISTANT_NEW_WEBVIEW =
  'ai_shopping_assistant_new-webview'
